
import { User } from './user';

export class CurrentProfile {
    public user: User;
    public token: string;

    constructor() {
        this.user = new User();

    }
}
